import { r as d, c as h, h as a, H as c, f as m, d as p, g as u } from "./main-bb89b2f2.js";
import { s as g } from "./synteticHtmlElementId-48c58699-07e8ae8e.js";
import "vue";
const f = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.collapse{visibility:collapse}.block{display:block}.flex{display:flex}.border-collapse{border-collapse:collapse}.border{border-width:1px}.outline{outline-style:solid}:host{all:unset;background-color:transparent;border-collapse:collapse;border-radius:0;border-spacing:0;box-sizing:border-box;color:inherit;display:block;font-family:inherit;font-size:100%;line-height:1.5;list-style:none;margin:0;min-width:0;padding:0;quotes:none;text-decoration:none;vertical-align:baseline}.component-element{--component-size:48px}.component-element.M{--component-size:40px}.component-element.S{--component-size:32px}.component-element.XS{--component-size:24px}.component-wrapper .component-element{fill:var(--texttoggle-text-default);align-items:center;background-color:var(--texttoggle-surface-default);border:1px solid var(--texttoggle-stroke-default);color:var(--texttoggle-text-default);display:flex;gap:7px;height:var(--component-size);padding-left:3px;padding-right:3px;width:-moz-max-content;width:max-content}.component-wrapper .component-element.XS{gap:5px;padding-left:2px;padding-right:2px}.component-wrapper .component-element:focus-within:not(.disabled){border-radius:0;outline:2px solid var(--texttoggle-stroke-focus);outline-offset:-2px}.component-wrapper .component-element.disabled{border:1px solid var(--texttoggle-stroke-disabled)}.static{position:static}.mt-\\[8px\\]{margin-top:8px}.items-center{align-items:center}", b = f, S = class {
  constructor(e) {
    d(this, e), this.changeEvent = h(this, "lhChange", 7), this._inputId = "", this.internalState = {
      disabled: !1,
      items: [],
      selectedItem: null,
      size: "big"
    }, this.handleKeyDown = (t) => {
      if (t.key === "ArrowLeft" || t.key === "ArrowRight") {
        this.handleKeyLeftRight(t);
        return;
      }
    }, this.additionalInfo = "", this.additionalInfoPosition = "top", this.controlled = !1, this.debug = !1, this.debugInfo = "", this.disabled = !1, this.inputId = "", this.label = "", this.name = "", this.placeholderSpaceForLabelArea = !1, this.placeholderSpaceForStatusLines = 0, this.size = "L", this.status = "", this.statusText = "", this.value = "", this.wcag = "AAA";
  }
  /** @internal */
  async getInternalState() {
    return Promise.resolve(this.internalState);
  }
  openTextToggle(e) {
    if (e.stopPropagation(), e.detail == null) {
      console.warn("[patternlib-texttoggle-v1] Item select event has no detail.");
      return;
    }
    this.preSelectItem(e.detail);
  }
  handleDisabled(e) {
    this.setStateDisabled(e);
  }
  sizeWatcher(e) {
    this.setStateSize(e);
  }
  // Signal value changs from outside or from inside
  valueWatcher(e) {
    e == null && (console.warn("[patternlib-texttoggle-v1] Value is null/undefined. This should not happen."), this.value = "", e = ""), this.handleValueChange(e);
  }
  componentWillLoad() {
    this.value == null && (console.warn("[patternlib-texttoggle-v1] Value is null/undefined. This should not happen."), this.value = ""), this.setStateSize(this.size), this.setStateDisabled(this.disabled), this._inputId = this.inputId === "" ? g() : this.inputId;
  }
  componentDidLoad() {
    this.handleValueChange(this.value);
  }
  componentWillRender() {
    this.internalState.items.forEach((e) => {
      e.element.debug = this.debug, e.element.disabled = this.internalState.disabled, e.element.ptsExpansions = this.wcag === "AAA", e.element.size = this.internalState.size;
    });
  }
  // eslint-disable-next-line complexity
  render() {
    const e = this.hostElement.querySelector('[slot="error-message"]') != null, t = this.hostElement.querySelector('[slot="success-message"]') != null, s = this.hostElement.querySelector('[slot="warning-message"]') != null, n = this.hostElement.querySelector('[slot="info-message"]') != null;
    let l = "", i = "";
    this.status === "error" || e ? (l = "error", i = this.statusText) : this.status === "success" || t ? (l = "success", i = this.statusText) : this.status === "warning" || s ? (l = "warning", i = this.statusText) : (this.status === "info" || n) && (l = "default", i = this.statusText);
    const o = {
      userSelect: "none",
      pointerEvents: this.disabled ? "none" : null
    }, r = {
      "component-element": !0,
      disabled: this.disabled,
      [this.internalState.size]: !0
    };
    return a(c, { key: "a7e57fd09962749ee63b135bd4b89bdfa0f8dffc", role: "radiogroup", "aria-disabled": this.disabled ? "true" : "false", "aria-label": this.label, style: o }, a("div", { key: "5acc6ecdfca014cf218c9f7c7c891473cce6a5e2", class: "component-wrapper" }, a("patternlib-form-group", { key: "9c50e2b2d1ee1013251f6231dd393fc77c067dca", additionalInfoPosition: this.additionalInfoPosition, "data-testid": "pl-form-group", labelId: this._inputId, reserveSpaceForLabelArea: this.placeholderSpaceForLabelArea, reserveSpaceForStatusLines: this.placeholderSpaceForStatusLines, status: l }, this.label == "" ? null : a("span", { slot: "label" }, this.label), this.additionalInfo == "" ? null : a("span", { slot: "additional-info" }, this.additionalInfo), a("div", { key: "c7e8e191c5e53993eda6d4770d4a4d00f9a56068", class: r, onKeyDown: this.handleKeyDown, slot: "element" }, a("slot", { key: "4b23516514f38f96e9e4276e832cb8a0baaf3c53", onSlotchange: () => this.handleItemsSlotChange() })), l === "error" && i !== "" && a("div", { key: "b068cc97c29fea6685671e567380a2fa871214a6", slot: "error-message" }, i), l === "default" && i !== "" && a("div", { key: "a9a56a0de5ce17fd1654a1a552eb9e961d0b86b5", slot: "info-message" }, i), l === "warning" && i !== "" && a("div", { key: "2ae1b06918753ab860b512afdf47c669166141ad", slot: "warning-message" }, i), l === "success" && i !== "" && a("div", { key: "7420b71ec8d4eb5a510883967e0b5d55e2e5ae30", slot: "success-message" }, i), e && a("slot", { key: "9860fe71e06d8879b207ad6c3bd72af4c2ac8297", name: "error-message", slot: "error-message" }), n && a("slot", { key: "186da38583d101c842d5bfd5f421474b1b421ad7", name: "info-message", slot: "info-message" }), t && a("slot", { key: "941dbad76444c4ea51b4f81b66452d47705d752b", name: "success-message", slot: "success-message" }), s && a("slot", { key: "0f2d45c53027472765a251902c71e56c91dcc35b", name: "warning-message", slot: "warning-message" }))));
  }
  setStateCollectItemsFromLightDOM() {
    this.internalState.items = [], Array.from(this.hostElement.querySelectorAll("patternlib-texttoggle-item-v1")).map((e) => {
      this.internalState.items.push({
        selected: e.selected,
        disabled: e.disabled,
        element: e
      });
    }), this.dumpState("setStateCollectItems");
  }
  setStateSelectedItem(e) {
    this.internalState.selectedItem = e, m(this), this.dumpState("setStateSelectedItem");
  }
  setStateDisabled(e) {
    this.internalState.disabled = e, this.dumpState("setStateDisabled");
  }
  setStateSize(e) {
    this.internalState.size = e, this.dumpState("setStateSize");
  }
  handleKeyLeftRight(e) {
    e.stopPropagation();
    let t = 0;
    this.internalState.items.forEach((n, l) => {
      n.element.selected && (t = l);
    });
    let s = t;
    e.key === "ArrowLeft" && (s--, s < 0 && (s = this.internalState.items.length - 1)), e.key === "ArrowRight" && (s++, s > this.internalState.items.length - 1 && (s = 0)), this.preSelectItem(this.internalState.items[s]), this.internalState.items[s].element.setFocus();
  }
  handleValueChange(e) {
    if (e === "")
      return;
    let t = null;
    for (const s of this.internalState.items)
      s.element.selected = !1, s.element.value == e && (t = s);
    t != null && (this.internalState.selectedItem == null || this.internalState.selectedItem.element.value !== t.element.value) && (t.element.selected = !0, this.setStateSelectedItem(t));
  }
  preSelectItem(e) {
    this.internalState.selectedItem != null && this.internalState.selectedItem.element.value === e.element.value || (this.controlled || (this.value = e.element.value), this.changeEvent.emit({ value: e.element.value, name: this.name }));
  }
  handleItemsSlotChange() {
    this.setStateCollectItemsFromLightDOM();
  }
  dumpState(e = "") {
    this.debug && p("TexttoggleV1", this.internalState, e, this.debugInfo);
  }
  get hostElement() {
    return u(this);
  }
  static get watchers() {
    return {
      disabled: ["handleDisabled"],
      size: ["sizeWatcher"],
      value: ["valueWatcher"]
    };
  }
};
S.style = b;
export {
  S as patternlib_texttoggle_v1
};
